import { render, staticRenderFns } from "./GangImage.vue?vue&type=template&id=74371e43&scoped=true&"
import script from "./GangImage.vue?vue&type=script&lang=js&"
export * from "./GangImage.vue?vue&type=script&lang=js&"
import style0 from "./GangImage.vue?vue&type=style&index=0&id=74371e43&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74371e43",
  null
  
)

export default component.exports